import { createAsyncThunk } from '@reduxjs/toolkit';

import { GROUP_NAME } from '@greenkub-fronts/shared/interface';

import { getCurrentProject } from '../../customer-area.slice';
import { pickCurrentProject } from '../pickCurrentProject/pick-current-project.use-case';

export const initCustomerArea = createAsyncThunk(
  'initCustomerArea',
  async (
    data: {},
    { dispatch, extra, getState }: { dispatch: any; extra: any; getState: any }
  ) => {
    /**
     * GetCatalogue
     */
    dispatch(
      extra.apiSlice.endpoints.getCatalogue.initiate({
        groupName: GROUP_NAME.CATALOGUE_FOR_CUSTOMER_AREA,
      })
    );

    /**
     * Get all project
     */
    await dispatch(
      extra.apiSlice.endpoints.getAllCustomerProjects.initiate({
        groupName: GROUP_NAME.PROJECTS_FOR_CUSTOMER_AREA,
      })
    );

    const currentProject = getCurrentProject(getState());

    if (currentProject === undefined) {
      dispatch(pickCurrentProject());
    }
  }
);
